import * as React from 'react';
import { withRouter } from 'next/router';
import Link from 'next/link';
import Text from 'components/core/Text';
import { Wrapper, ListWrapper, FilledBlock, UpdateLink } from './styles';
import AnswerBlock from './components/AnswerBlock';
import EmptyState from './components/EmptyState';

class Information extends React.Component {
  getAnswer = (answers) =>
    answers && answers.length
      ? answers
          .map((answer) => {
            const preAnswers = answer.textField ? answer.textValue : answer.title;

            if (answer.items && answer.items.length) {
              const preSubAnswers = this.getPreSubAnswers(answer);

              return `${preAnswers} (${preSubAnswers})`;
            }

            return preAnswers;
          })
          .join(', ')
      : null;

  getPreSubAnswers = (answer) => {
    return answer.items.map((item) => (item.textField ? item.textValue : item.title)).join(', ');
  };

  renderAnswers = (answers) => {
    return answers.map((item) => (
      <AnswerBlock key={item.id} answer={this.getAnswer(item.answers)} question={item.title} />
    ));
  };

  renderState = (answers) => {
    if (answers && answers.length) {
      return (
        <FilledBlock>
          <Text variant="sectionHeader" tag="p" transform="uppercase" color="black">
            Profile Details
          </Text>
          <ListWrapper>{this.renderAnswers(answers)}</ListWrapper>
          <Link href="/questionnaire">
            <a href="/questionnaire">
              <UpdateLink>
                <Text weight="bold" tag="span" transform="uppercase" align="center">
                  🙋🏻‍♀️ update your questionnaire
                </Text>
              </UpdateLink>
            </a>
          </Link>
        </FilledBlock>
      );
    }
    return <EmptyState />;
  };

  render() {
    const { answers } = this.props;
    return <Wrapper>{this.renderState(answers)}</Wrapper>;
  }
}

export default withRouter(Information);
